import { Grid } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import * as React from "react";
import { Button, Toolbar } from "react-admin";
import RequestSptCreate from "./Create/RequestSptCreate";
import RequestSptEdit from "./Edit/RequestSptEdit";
import RequestSptList from "./List/RequestSptList";

const useStyles = makeStyles({
  toolbar: {
    flex: "auto",
    justifyContent: "flex-end",
    backgroundColor: "white",
    minHeight: 20,
    margin: 0,
  },
  defaultToolbar: {
    flex: "auto",
    justifyContent: "flex-end",
    minHeight: 20,
    margin: 0,
  },
});

const RequestSpt = props => {
  const classes = useStyles();
  const [isCreate, setIsCreate] = React.useState(!(props.requestSpt?.length > 0));
  const [isUpdate, setIsUpdate] = React.useState(false);
  const [updateItem, setUpdateItem] = React.useState({});
  const rowSelect = id => {
    setUpdateItem(props?.requestSpt?.find?.(x => x.id == id) ?? {});
    setIsUpdate(true);
  };
  const operationCallBack = () => {
    setIsUpdate(false);
    setIsCreate(false);
    props?.parentCallBack?.();
  };
  const onCreate = e => {
    setIsCreate(true);
  };

  return (
    <Grid container spacing={2}>
      {isCreate && (
        <Grid item xs={12} sm={12}>
          <RequestSptCreate
            resource="/requestspts"
            basePath=""
            requestId={props.requestId}
            finalCallBack={operationCallBack}
          />
        </Grid>
      )}
      {isUpdate && (
        <Grid item xs={12} sm={12}>
          <RequestSptEdit
            requestSpt={updateItem}
            requestDetailData={props.requestDetailData}
            requestId={props.requestId}
            finalCallBack={operationCallBack}
          />
        </Grid>
      )}
      <Grid item xs={12} sm={12}>
        <Toolbar {...props} placeholder="" classes={classes}>
          {!(isCreate || isUpdate) && (
            <Button label={"Create"} size="small" color="primary" onClick={onCreate}>
              <Add style={{ fontSize: 18, paddingBottom: 5 }} />
            </Button>
          )}
        </Toolbar>
      </Grid>
      {!(isCreate || isUpdate) && (
        <Grid item xs={12} sm={12}>
          <RequestSptList
            onRowSelect={rowSelect}
            resource="/requestspts"
            basePath="requestspts"
            requestSpt={props.requestSpt}
            requestDetailData={props.requestDetailData}
            requestId={props.requestId}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default RequestSpt;
